import React from 'react';
import Header from '../../_components/header/header';
import Footer from '../../_components/footer/footer';
import { Col, Row, Container } from 'reactstrap';
import LeftMenu from '../../_components/cards/LeftMenu';
import SettingsCard from '../../_components/cards/SettingsCard';
class Settings extends React.Component {
    render() {
        return (
            <>
                {/* <Header /> */}
                <Container fluid={true}>
                    <section className="dashboard-page">
                        <h2 className="dashboard-heading">Settings</h2>
                        <Row>
                            <Col md={{ size: "9" }}>
                                <SettingsCard />
                            </Col>
                            <Col md={{ size: "3" }}>
                                <LeftMenu />
                            </Col>
                        </Row>
                    </section>
                </Container>
                {/* <Footer /> */}
            </>
        )
    }
}
export default Settings